import { render } from "./GoalCategoryEdit.vue?vue&type=template&id=91fa06c6&scoped=true"
import script from "./GoalCategoryEdit.vue?vue&type=script&lang=js"
export * from "./GoalCategoryEdit.vue?vue&type=script&lang=js"

import "./GoalCategoryEdit.vue?vue&type=style&index=0&id=91fa06c6&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91fa06c6"]])

export default __exports__